<template>
  <multiselect
    :filterable="true"
    :options="options"
    v-model="selected"
    :custom-label="label"
    :placeholder="placeholder" />
</template>

<script>
import vSelect from "vue-select";
export default {
  components: {
    vSelect,
  },
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    draw: {
      type: Number,
    },
    placeholder: {
      type: String
    },
    value: {
      type: Object
    },
    taxTypeID: {
      type: Number,
    }
  },
  data() {
    return {
      baseUrl: "/api/sfa/v1/master/facility-ref",
      options: [],
      selected: (this.multiple) ? [] : null
    };
  },
  methods: {
    get() {
      if (this.taxTypeID) {
        this.$http
          .get(this.baseUrl, {
            params: {
              order: "id",
              sort: "asc",
              by_personal: 1,
              tax_type_id: this.taxTypeID,
            }
          })
          .then(resp => {
            if (resp.code === 200) {
              resp.data.records.map(x => {
                x.label = x.code + " - " + x.description;
                return x;
              });

              this.options = resp.data.records;
              const defaultItem = this.options.find(x => x.is_default);

              if (defaultItem) {
                this.selected = this.multiple ? [defaultItem] : defaultItem;
                this.$emit('selected', this.selected);
              }

            } else {
              this.options = [];
              console.log(resp.data);
            }
          });
      }
    },
    label(option) {
      return option.label;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (val) {
          this.selected = val;
        }
      }
    },
    selected(newVal) {
      this.$emit('selected', newVal);
    },
    taxTypeID() {
      this.get();
    }
  }
};
</script>
